import { KiTagListOptions } from '../schemas';

/**
 * お気に入りに保存されたタグ絞り込みから、復元するタグ ID を決める。
 *
 * タグはマスタ更新で削除され得るため、現在のタグ一覧に無い ID は除外する
 * （除外しないと絞り込みは効くのにヘッダーへタグが出ず全件非表示に見える）。
 *
 * `kiTagOptions` が undefined のときはマスタ未取得として保存 ID をそのまま返す。
 * 空配列は取得済みだが 0 件（削除済み含む）として保存 ID を復元しない。
 */
export const resolveFavoriteFilteredKiTagIds = (
  savedKiTagIds: number[] | undefined,
  kiTagOptions: KiTagListOptions[] | undefined
): number[] => {
  if (savedKiTagIds == null || savedKiTagIds.length === 0) {
    return [];
  }

  if (kiTagOptions === undefined) {
    return savedKiTagIds;
  }

  const availableTagIds = new Set(kiTagOptions.map((tag) => tag.tagId));
  return savedKiTagIds.filter((tagId) => availableTagIds.has(tagId));
};
